import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { PostAppGroupIdBrazeDocsSearchResult } from "./types";

export const isPostAppGroupIdBrazeDocsSearchResult = objectOf<PostAppGroupIdBrazeDocsSearchResult>({
  results: string,
});
